<section class="pss-dashboard-page container-fluid p-0 d-grid gap-1 ">
<header
  class="page-toolbar d-flex flex-column flex-xl-row align-items-xl-center "
>
  <h1 class="h5 mb-0">
    PSS Dashboard <span class="fw-bold"> /</span>
    <span class="fw-bold">{{ pss().name }}</span>
  </h1>

  <section
    class="filter-card d-flex gap-2 ms-xl-auto"
    aria-label="PSS dashboard filters"
  >
    <select
      class="form-select form-select-sm bg-white ms-auto"
      aria-label="PSS"
      [value]="selectedPssCode()"
      (change)="selectedPssCode.set($any($event.target).value)"
    >
      @for (option of pssRows; track option.code) {
        <option [value]="option.code" [selected]="option.code === selectedPssCode()">
          {{ option.name }} ({{ option.code }})
        </option>
      }
    </select>

    <input
      class="form-control form-control-sm"
      aria-label="Date"
      type="date"
      [value]="selectedDate()"
      (change)="selectedDate.set($any($event.target).value)"
    />

    <button
      type="button"
      class="primary-button btn btn-primary btn-lg"
      (click)="applyFilters()"
    >
      Go
    </button>

    <button
      type="button"
      class="secondary-button btn btn-outline-secondary btn-lg"
      (click)="resetFilters()"
    >
      Reset
    </button>
  </section>
</header>
  <section class="summary-ribbon" aria-label="PSS summary">
    @for (card of cards(); track card.label) {
    <article class="stat-card card h-100 border shadow-sm" [class]="card.tone">
      <span class="stat-icon">{{ card.icon }}</span>
      <div>
        <span class="stat-label">{{ card.label }}</span
        ><strong>{{ card.value }}</strong><small>{{ card.caption }}</small>
      </div>
    </article>
    }
    <article class="stat-card card h-100 border shadow-sm curtailment-issued">
      <span class="stat-icon stat-icon--svg" aria-hidden="true"
        ><svg viewBox="0 0 32 32">
          <path d="M4 10 16 4l12 6-12 6L4 10Z" />
          <path d="m4 15 12 6 12-6M4 20l12 6 12-6" /></svg
      ></span>
      <div>
        <span class="stat-label">Total Curtailment Issued (Today)</span
        ><strong>{{ profile().curtailment.totalEvents }}</strong
        ><small> Total Quantum: {{ profile().curtailment.totalMw }} MW </small>
      </div>
    </article>
    <article class="stat-card card h-100 border shadow-sm curtailment-moderation">
      <span class="stat-icon stat-icon--svg" aria-hidden="true"
        ><svg viewBox="0 0 32 32">
          <path
            d="M16 4v24M8 9l8-5 8 5M7 13h18M10 13l-3 13h6l3-13m6 0-3 13h6l-3-13"
          /></svg
      ></span>
      <div>
        <span class="stat-label">Total Moderation Issued (Today)</span
        ><strong>{{ profile().curtailment.moderationEvents }}</strong
        ><small> Total Quantum: {{ profile().curtailment.moderationMw }} MW </small>
      </div>
    </article>
    <article class="stat-card card h-100 border shadow-sm curtailment-active">
      <span class="stat-icon stat-icon--svg" aria-hidden="true"
        ><svg viewBox="0 0 32 32">
          <path
            d="M8 25V14a8 8 0 1 1 16 0v11M5 25h22M12 14v-2a4 4 0 0 1 8 0v2M16 6v-2M7 10 5 8m20 2 2-2"
          /></svg
      ></span>
      <div>
        <span class="stat-label">Active Curtailment</span
        ><strong>{{ profile().curtailment.activeEvents }}</strong
        ><small> Active Quantum: {{ profile().curtailment.activeMw }} MW </small>
      </div>
    </article>
    <article class="stat-card card h-100 border shadow-sm curtailment-relief">
      <span class="stat-icon stat-icon--svg" aria-hidden="true"
        ><svg viewBox="0 0 32 32">
          <path d="M22 7a10 10 0 1 0 3 14" />
          <path d="M22 7v7h-7M12 18l3 3 6-7" /></svg
      ></span>
      <div>
        <span class="stat-label">Total Relief Achieved (Today)</span
        ><strong>{{ format(profile().curtailment.reliefMw) }} MW</strong
        ><small>Target Quantum: {{ profile().curtailment.targetMw }} MW</small>
      </div>
    </article>
  </section>

  <section class="top-grid row g-2 m-0">
    <article class="panel hierarchy-panel card col-12 col-xl-7 p-2">
      <div class="panel-heading">
        <div><h2>Evacuation Network Hierarchy ({{ pss().code }})</h2></div>
      </div>
      <div class="network-scroll">
        <div class="network-map">
          <div class="network-column pss-node">
            <h3>PSS (Owned by)</h3>
            <div class="network-node">
              ⚡ <strong>{{ pss().name }}</strong
              ><small>{{ pss().code }} · 1 mapped Path</small>
            </div>
          </div>
          <div class="network-connector-lane" aria-hidden="true">
            <span class="network-connector-lane__line"></span>
            <span class="network-connector-lane__arrow">›</span>
          </div>
          <div class="network-column links">
            <h3>Link (Immediate Network)</h3>
            @for (link of links(); track link.code) {
            <div class="network-node">
              <strong>{{ link.name }}</strong>
              <small>
                {{ pss().name }} →
                {{ pathForLink(link.code)?.name || 'Not mapped' }}
              </small>
            </div>
            }
          </div>
          <div class="network-connector-lane" aria-hidden="true">
            <span class="network-connector-lane__line"></span>
            <span class="network-connector-lane__arrow">›</span>
          </div>
          <div class="network-column paths">
            <h3>Path (Beyond Link)</h3>
            @for (path of paths(); track path.id) {
            <div class="network-node">
              <strong>{{ path.name }}</strong>
              <small>{{ pss().name }} · {{ path.code }}</small>
            </div>
            }
          </div>
          <div class="network-connector-lane" aria-hidden="true">
            <span class="network-connector-lane__line"></span>
            <span class="network-connector-lane__arrow">›</span>
          </div>
          <div class="network-column districts">
            <h3>Districts</h3>
            @for (district of districts(); track district) {
            <div class="network-node">
              <strong>{{ district }}</strong>
            </div>
            }
          </div>
          <div class="network-connector-lane" aria-hidden="true">
            <span class="network-connector-lane__line"></span>
            <span class="network-connector-lane__arrow">›</span>
          </div>
          <div class="network-column flows">
            <h3>Flow Area (via Contracts)</h3>
            @for (flow of flowAreas(); track flow) {
            <div class="network-node">
              <strong>{{ flow }}</strong>
            </div>
            }
          </div>
        </div>
      </div>
    </article>
    <section class="contract-stack col-12 col-xl-5 d-grid gap-2 p-0">
      <article class="panel contract-panel card p-2">
        <div class="panel-heading">
          <div><h2>▧ Intra-State Contract Summary</h2></div>
          <button class="link-button" type="button">View All</button>
        </div>
        <div class="compact-table table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>Contract ID</th>
                <th>Flow Area</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Direction</th>
                <th>Capacity (MW)</th>
                <th>ATC</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (contract of profile().intraStateContracts; track
              contract.id) {
              <tr>
                <td>{{ contract.id }}</td>
                <td>{{ contract.flowArea }}</td>
                <td>{{ contract.start }}</td>
                <td>{{ contract.end }}</td>
                <td>{{ contract.direction }}</td>
                <td>{{ contract.capacityMw }}</td>
                <td>{{ contract.atcMw }}</td>
                <td><span class="status-pill">{{ contract.status }}</span></td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </article>
      <article class="panel contract-panel card p-2">
        <div class="panel-heading">
          <div><h2>▧ Inter-State Contract Summary</h2></div>
          <button class="link-button" type="button">View All</button>
        </div>
        <div class="compact-table table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>Contract ID</th>
                <th>Flow Area</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Direction</th>
                <th>Capacity (MW)</th>
                <th>ATC</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (contract of profile().interStateContracts; track
              contract.id) {
              <tr>
                <td>{{ contract.id }}</td>
                <td>{{ contract.flowArea }}</td>
                <td>{{ contract.start }}</td>
                <td>{{ contract.end }}</td>
                <td>{{ contract.direction }}</td>
                <td>{{ contract.capacityMw }}</td>
                <td>{{ contract.atcMw }}</td>
                <td><span class="status-pill">{{ contract.status }}</span></td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </article>
    </section>
  </section>

  <section class="middle-grid row g-2 m-0">
    <article class="panel unit-panel card col-12 col-xl-6 p-2">
      <div class="panel-heading">
        <div>
          <h2>
            Unit / Generator wise Schedule vs Actual vs Deviation vs DSM
          </h2>
        </div>
      </div>
      <div class="table-filters d-flex flex-wrap gap-2 mb-2">
        <select class="form-select form-select-sm table-filter-select">
          <option>All Plants</option></select
        ><select class="form-select form-select-sm table-filter-select">
          <option>All Generators</option></select
        ><select class="form-select form-select-sm table-filter-select">
          <option>All Units</option></select
        ><select
          class="form-select form-select-sm table-filter-select"
          aria-label="DSM block"
          [value]="selectedTimeBlock()"
          (change)="onTimeBlockChange($any($event.target).value)"
        >
          @for (blockWindow of timeBlockOptions; track blockWindow; let index = $index) {
            <option
              [value]="blockWindow"
              [selected]="blockWindow === selectedTimeBlock()"
            >
              Block {{ index + 1 }} · {{ blockWindow }}
            </option>
          }
        </select
        ><label class="table-filter-toggle"
          ><input class="form-check-input m-0" type="checkbox" checked /> Show
          DSM</label
        >
      </div>
      <div class="compact-table table-responsive">
        <table class="table table-sm table-bordered mb-0">
          <thead>
            <tr>
              <th>Plant / Generator</th>
              <th>Unit</th>
              <th>Capacity (MW)</th>
              <th>Schedule (MW)</th>
              <th>AvC (MW)</th>
              <th>Actual (MW)</th>
              <th>Deviation (MW)</th>
              <th>DSM</th>
              <th>Net Position (MW)</th>
            </tr>
          </thead>
          <tbody>
            @for (row of profile().unitScheduleRows; track row.unit) {
            <tr>
              <td>{{ row.plant }}</td>
              <td>{{ row.unit }}</td>
              <td>{{ row.capacity }}</td>
              <td>{{ row.schedule }}</td>
              <td>{{ row.avc }}</td>
              <td>{{ row.actual }}</td>
              <td
                [class.negative]="row.deviation < 0"
                [class.positive]="row.deviation > 0"
              >
                {{ row.deviation }}
              </td>
              <td>{{ row.dsm }}</td>
              <td><span class="status-pill">{{ row.status }}</span></td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </article>
    <article #revisionTrendPanel class="panel revision-panel card col-12 col-xl-6 p-2 ">
      <div class="row g-2 h-100">
        <section class="col-12 col-xl-12 ">
          <div class="panel-heading">
            <div><h2>Revision Trend (MW)</h2></div>
            <div class="chart-header-actions">
              <div class="chart-filter">
                <label>
                  <span class="sr-only">Revision trend interval</span>
                  <select
                    aria-label="Revision trend interval"
                    [value]="revisionTrendResolution()"
                    (change)="setRevisionTrendResolution($any($event.target).value)"
                  >
                    <option value="hour">Hour</option>
                    <option value="block">Block</option>
                  </select>
                </label>
              </div>
              <button
                class="fullscreen-button"
                type="button"
                title="View revision trend in full screen"
                aria-label="View revision trend in full screen"
                (click)="toggleRevisionTrendFullscreen()"
              >⛶</button>
            </div>
          </div>
          <div
            #revisionTrendChart
            class="revision-trend-chart"
            aria-label="Interactive schedule, actual and deviation trend"
          ></div>
        </section>

      </div>
    </article>
  </section>

  <section class="bottom-grid row g-2 m-0">
    <article class="panel curtailment-panel card col-12 col-xl-7 p-2">
      <div class="panel-heading">
        <div><h2>Recent Curtailment Records</h2></div>
      </div>
      <div class="compact-table table-responsive">
        <table class="table table-sm table-bordered mb-0">
          <thead>
            <tr>
              <th>Curtailment ID</th>
              <th>Issue Date &amp; Time</th>
              <th>Type</th>
              <th>Selection Criteria</th>
              <th>Quantity</th>
              <th>Expected Relief</th>
              <th>Achieved Relief</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (record of profile().curtailmentRecords; track record.id) {
            <tr>
              <td>{{ record.id }}</td>
              <td>{{ record.issued }}</td>
              <td>{{ record.type }}</td>
              <td>{{ record.criteria }}</td>
              <td>{{ record.quantity }} MW</td>
              <td>{{ record.expected }} MW</td>
              <td>{{ record.achieved }} MW</td>
              <td><span class="status-pill">{{ record.status }}</span></td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </article>
    <article class="panel latest-revision-panel card col-12 col-xl-5 p-2">
      <div class="panel-heading">
        <div>
          <h2>Latest Revision Details (Block: {{ selectedTimeBlock() }})</h2>
        </div>
      </div>
      <div class="compact-table table-responsive">
        <table class="table table-sm table-bordered mb-0">
          <thead>
            <tr>
              <th>Revision Type</th>
              <th>No.</th>
              <th>Published</th>
              <th>Schedule(MW)</th>
              <th>Actual(MW)</th>
              <th>Deviation(MW)</th>
              <th>DSM Up(MW)</th>
              <th>DSM Down(MW)</th>
            </tr>
          </thead>
          <tbody>
            @for (revision of profile().revisionRows; track revision.type) {
              <tr>
                <td>{{ revision.type }}</td>
                <td>{{ revision.number }}</td>
                <td>{{ revision.publishedAt }}</td>
                <td>{{ revision.scheduleMw }}</td>
                <td>{{ revision.actualMw }}</td>
                <td class="negative">{{ revision.deviationMw }}</td>
                <td class="positive">{{ revision.dsmUpMw }}</td>
                <td class="negative">{{ revision.dsmDownMw }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </article>
    <!-- <aside class="panel quick-actions">
      <h2>Quick Actions</h2>
      <button>◌ Issue Curtailment</button><button>◌ Issue Moderation</button
      ><button>◌ View Curtailment History</button
      ><button>◌ View Moderation History</button><button>⇩ Export Data</button>
      <h3>Key Points</h3>
      <p>
        Links, Paths, Districts and Flow Areas remain linked to the selected
        PSS.
      </p>
      <h3>Data Sharing</h3>
      <p>
        WRLDC WBES data-sharing mappings are available for active contracts.
      </p>
    </aside> -->
  </section>
</section>
